import { IFaireIcon } from '@faire/web-api--source/indigofair/data/IFaireIcon';

export namespace IInformationMessage {
  export enum Style {
    STYLE_UNKNOWN = 'STYLE_UNKNOWN',
    REGULAR = 'REGULAR',
    PROMO = 'PROMO',
  }

  export enum Type {
    TYPE_UNKNOWN = 'TYPE_UNKNOWN',
    BASED_IN = 'BASED_IN',
    SHIPS_FROM = 'SHIPS_FROM',
    ORDER_FULFILLMENT_TIME = 'ORDER_FULFILLMENT_TIME',
    PREORDER = 'PREORDER',
    INTERNATIONAL_SHIPPING_PROMO = 'INTERNATIONAL_SHIPPING_PROMO',
    INTERNATIONAL_DUTIES_PROMO = 'INTERNATIONAL_DUTIES_PROMO',
    CATEGORY_RESTRICTION = 'CATEGORY_RESTRICTION',
    INSIDER_UPSELL = 'INSIDER_UPSELL',
    INSIDER_EVENT_CHECKOUT_UPSELL = 'INSIDER_EVENT_CHECKOUT_UPSELL',
    GREEN_SHIPPING_UPSELL = 'GREEN_SHIPPING_UPSELL',
    FAIRE_FUNDED_PROMO_BANNER = 'FAIRE_FUNDED_PROMO_BANNER',
    INSIDER_UNPAID_NOTICE = 'INSIDER_UNPAID_NOTICE',
    INSIDER_UNPAID_RECOVER = 'INSIDER_UNPAID_RECOVER',
    ZERO_DOLLAR_ORDER = 'ZERO_DOLLAR_ORDER',
    ZERO_DOLLAR_ORDER_WITH_ADDITIONAL_COST = 'ZERO_DOLLAR_ORDER_WITH_ADDITIONAL_COST',
    BACKORDERED_ORDER = 'BACKORDERED_ORDER',
    IDV_REQUIRED = 'IDV_REQUIRED',
    AWAITING_APPROVAL = 'AWAITING_APPROVAL',
    AWAITING_PAYMENT_METHOD = 'AWAITING_PAYMENT_METHOD',
    APPAREL_NEW_USER_EXPERIENCE = 'APPAREL_NEW_USER_EXPERIENCE',
    FIRST_ORDER_PROMO = 'FIRST_ORDER_PROMO',
    SHIPPING_ESTIMATE = 'SHIPPING_ESTIMATE',
    MARKET_PROMO = 'MARKET_PROMO',
    GET_IT_BY = 'GET_IT_BY',
    EXCLUSIVITY_PROMO_BANNER = 'EXCLUSIVITY_PROMO_BANNER',
    SHIPPING_COST_ESTIMATE_BREAKDOWN = 'SHIPPING_COST_ESTIMATE_BREAKDOWN',
    INSIDER_UNDER_THRESHOLD = 'INSIDER_UNDER_THRESHOLD',
    FREE_RETURNS_ON_FIRST_ORDER = 'FREE_RETURNS_ON_FIRST_ORDER',
    EXCLUSIVITY_AVAILABLE = 'EXCLUSIVITY_AVAILABLE',
    EXCLUSIVITY_ACTIVE = 'EXCLUSIVITY_ACTIVE',
    FAIRE_FUNDED_GUARANTEED_SHIPPING = 'FAIRE_FUNDED_GUARANTEED_SHIPPING',
    FAIRE_FUNDED_GUARANTEED_SHIPPING_WITH_DISCLAIMER = 'FAIRE_FUNDED_GUARANTEED_SHIPPING_WITH_DISCLAIMER',
    GUARANTEED_FREE_SHIPPING_THRESHOLD = 'GUARANTEED_FREE_SHIPPING_THRESHOLD',
    SHIPPING_COST_SAVING = 'SHIPPING_COST_SAVING',
    VOLUME_PRICING = 'VOLUME_PRICING',
    FAIRE_SOURCE_BADGE = 'FAIRE_SOURCE_BADGE',
    FAIRE_SOURCE_BANNER = 'FAIRE_SOURCE_BANNER',
  }

  export enum Position {
    POSITION_UNKNOWN = 'POSITION_UNKNOWN',
    DEFAULT = 'DEFAULT',
    BOTTOM = 'BOTTOM',
    BELOW_ORDER_MINIMUM = 'BELOW_ORDER_MINIMUM',
  }

  /**
   * Return an instance of IInformationMessage with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IInformationMessage>
  ): IInformationMessage =>
    ({
      ...(partial ?? {}),
    }) as IInformationMessage;
}

export interface IInformationMessage {
  /**
   * Faire CDN URL of the icon's PNG
   */
  icon_url: string | undefined;
  /**
   * If present, this takes priority over iconUrl
   */
  icon: IFaireIcon | undefined;
  title: string | undefined;
  title_color: string | undefined;
  text: string | undefined;
  compact_text: string | undefined;
  /**
   * RGB for the text color in the format FFFFFF
   */
  text_color: string | undefined;
  background_color: string | undefined;
  /**
   * when provided, this supplies the right-most gradient color while backgroundColor provides the left-most.
   */
  background_color_gradient: string | undefined;
  tooltip_title: string | undefined;
  tooltip: string | undefined;
  help_link: string | undefined;
  style: keyof typeof IInformationMessage.Style | undefined;
  type: keyof typeof IInformationMessage.Type | undefined;
  message_prefix: string | undefined;
  prefix_color: string | undefined;
  position: keyof typeof IInformationMessage.Position | undefined;
  help_link_uri: string | undefined;
  /**
   * For insider banners
   */
  cta_text: string | undefined;
  subtitle: string | undefined;
}
